import React from 'react';

const Down: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		aria-hidden="true"
		role="presentation"
	>
		<path d="M6 10l1.41-1.41L12 13.17l4.59-4.58L18 10l-6 6z" />
		<path d="M0 0h24v24H0z" fill="none" />
	</svg>
);

export default Down;
